module.exports = __webpack_public_path__ + "img/16581313_L.ca2eba60.png";